import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import { Taxpayer } from '@/store/types';
import { taxpayerTypes } from '@/store/mapping';
import { dateFormat, numGroup } from '@/utils/filters';

export default class TaxpayerStore extends ListStore<Taxpayer> {
  @computed get processedData() {
    if (!this.data) return;
    const taxes = Object.values(this.data.taxes).reduce((acc, item) => {
      acc[item.accountType] = item;
      return acc;
    }, {} as Record<string, any>);
    return {
      ...this.data,
      type: taxpayerTypes[this.data.type]?.label || '-',
      createDate: dateFormat(this.data.createDate, {
        format: 'DD.MM.YYYY',
        addHours: 0,
      }),
      sumIncome: numGroup(this.data.sumIncome),
      sumTax: numGroup(this.data.sumTax),
      sumPayTax: numGroup(this.data.sumPayTax),
      sumDebt: numGroup(this.data.sumDebt),
      sumAccrual: numGroup(this.data.sumAccrual),
      sumDebtAccrual: numGroup(this.data.sumDebtAccrual),
      sumPayAccrual: numGroup(this.data.sumPayAccrual),
      IIT: {
        tax: taxes.IIT?.tax?.toLocaleString('ru-RU') || '0',
        payTax: taxes.IIT?.payTax?.toLocaleString('ru-RU') || '0',
        debt: taxes.IIT?.debt?.toLocaleString('ru-RU') || '0',
      },
      SC: {
        tax: taxes.SC?.tax?.toLocaleString('ru-RU') || '0',
        payTax: taxes.SC?.payTax?.toLocaleString('ru-RU') || '0',
        debt: taxes.SC?.debt?.toLocaleString('ru-RU') || '0',
      },
      MPC: {
        tax: taxes.MPC?.tax?.toLocaleString('ru-RU') || '0',
        payTax: taxes.MPC?.payTax?.toLocaleString('ru-RU') || '0',
        debt: taxes.MPC?.debt?.toLocaleString('ru-RU') || '0',
      },
      CCSHI: {
        tax: taxes.CCSHI?.tax?.toLocaleString('ru-RU') || '0',
        payTax: taxes.CCSHI?.payTax?.toLocaleString('ru-RU') || '0',
        debt: taxes.CCSHI?.debt?.toLocaleString('ru-RU') || '0',
      },
    };
  }

  @action.bound
  async fetch(id: string | number) {
    this.isFetching = true;
    try {
      const { data } = await services.selfEmployee.getTaxpayerProfile(id);
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
